import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    background: #ffffff;
    font-family: sans-serif;
    overflow-x: hidden;
  }
`;

export default GlobalStyle;

//TODO: 
/**
 * do a once over clean up when freedie shares videos materials
 * -> turn the map area to scale
 * -> center clicked videos
 * -> put initials in background.
 */